export default __webpack_public_path__ + "6d87c75c77c41bf1845a49cb8702ef3e.png";